import { Store } from 'redux';
import { CurrentDateRangeService, CurrentEmployeeService } from 'lib';
import { IAppState, IStore } from 'store/types';
import { getDefaultDateRange } from './reducer';

// The profile and date range survive a reload: loadAppState reads them back when the store is created, and
// persistAppState saves them whenever app changes.
export const loadAppState = (): IAppState => {
  try {
    const currentEmployee = CurrentEmployeeService.get();
    if (!currentEmployee) return {};
    return { currentEmployee, currentDateRange: CurrentDateRangeService.get() ?? getDefaultDateRange() };
  } catch {
    return {}; // unreadable storage: start with nothing chosen instead of failing to load
  }
};

export const persistAppState = (store: Store<IStore>) => {
  let saved = store.getState().app;

  store.subscribe(() => {
    const { app } = store.getState();
    if (app.currentEmployee === saved.currentEmployee && app.currentDateRange === saved.currentDateRange) return;
    saved = app;

    try {
      // Only a profile's view is restored after a reload; the employee dashboard, or being logged out, keeps nothing.
      if (app.currentEmployee) {
        CurrentEmployeeService.set(app.currentEmployee);
        CurrentDateRangeService.set(app.currentDateRange);
      } else {
        CurrentEmployeeService.clear();
        CurrentDateRangeService.clear();
      }
    } catch {
      // Storage can be full or blocked; the state in memory is still right, it just won't survive a reload.
    }
  });
};
